import React from 'react';
import { Container, Text, Heading } from '@chakra-ui/react';

const EditNavigation = () => {
  return (
    <Container maxW="container.lg" py={6}>
      <Heading size="lg" mb={4}>Edit Navigation</Heading>
      <Text>Edit navigation form coming soon...</Text>
    </Container>
  );
};

export default EditNavigation;